//#region Libraries
import { useState } from "react";
//#endregion
//#region Components
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import SelectBlock from "./components/SelectBlock/SelectBlock";
import InputTime from "./components/InputTime/InputTime";
//#endregion
//#region Styles
import { 
    Container,
    Content } from "./styles";
//#endregion
import { 
    getText,
    getTimeParts 
} from "./utils";

const CustomTime = ({
    label, 
    caption,
    interval, 
    onChange, 
    value = -1,
    error = false,
    errorText,
    disabled, 
    disabledHours = [],
    ratioMinutesTime = 15
}) => {
    //#region States
    const [showSelectBlock, setShowSelectBlock] = useState(false);
    //#endregion
    //#region Functions
    const getTextForInput = () => {
        if (value === -1)
            return null;
        const time = getTimeParts(value);
        return getText(time);
    }
    const toggleShowSelectBlock = () => {
        setShowSelectBlock(prev => !prev);
    }
    const changeValue = timestamp => {
        onChange && onChange(timestamp);
        toggleShowSelectBlock();
    }
    //#endregion
    return (
        <Container>
            {label && <label>{label}</label>}
            <Content
                tabIndex={0}
                onBlur={() => setShowSelectBlock(false)}
                className={disabled ? "disabled" : ""}>
                <InputTime 
                    disabled={disabled}
                    error={error}
                    text={getTextForInput()} 
                    onClick={toggleShowSelectBlock}/>
                {showSelectBlock && 
                <SelectBlock 
                    caption={caption} 
                    interval={interval}
                    disabledHours={disabledHours}
                    value={value}
                    changeValue={changeValue}
                    ratioMinutesTime={ratioMinutesTime}/>}
                <ErrorMessage
                    text={errorText}
                    error={error}/>
            </Content>
        </Container>
    );
}


export default CustomTime;